import React from 'react';
import ReactDOM from 'react-dom';
import './stripeRequiredDialog.css';

const STATE_COPY = {
  not_connected: 'Connect a club Stripe account before using this paid feature.',
  onboarding_incomplete: 'Finish the club’s Stripe onboarding before using this paid feature.',
  restricted: 'The connected Stripe account needs attention before Member Nest can take another payment.',
};

export default function StripeRequiredDialog({
  open,
  state,
  featureLabel,
  canManageStripe,
  busy,
  error,
  onContinue,
  onClose,
}) {
  if (!open || typeof document === 'undefined') return null;
  const loading = state === 'checking';
  return ReactDOM.createPortal(
    <div className="modal-backdrop stripe-required-backdrop" onClick={(event) => {
      event.stopPropagation();
      if (!busy) onClose?.();
    }}>
      <section
        className="modal-content stripe-required-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="stripe-required-title"
        onClick={(event) => event.stopPropagation()}
      >
        <p className="stripe-required-dialog__eyebrow">Payments setup</p>
        <h2 id="stripe-required-title">{loading ? 'Checking Stripe…' : 'Stripe setup required'}</h2>
        {loading ? (
          <div className="stripe-required-dialog__loading" role="status">
            <span className="stripe-required-dialog__spinner" aria-hidden="true" />
            <span>Checking whether the club can accept payments.</span>
          </div>
        ) : (
          <>
            <p><strong>{featureLabel}</strong> can collect money, so the club must have an operational Stripe account first.</p>
            <p>{STATE_COPY[state] || 'Stripe setup must be completed before continuing.'}</p>
            {!canManageStripe && (
              <div className="stripe-required-dialog__notice" role="status">
                Ask a full club admin or an admin with Finance permission to complete Stripe setup.
              </div>
            )}
          </>
        )}
        {error && <p className="error-message" role="alert">{error}</p>}
        <div className="form-actions stripe-required-dialog__actions">
          <button type="button" className="button button-secondary" onClick={onClose} disabled={busy}>Cancel</button>
          {!loading && canManageStripe && (
            <button type="button" className="button button-primary" onClick={onContinue} disabled={busy}>
              {busy ? 'Opening Stripe…' : state === 'restricted' ? 'Resolve in Stripe' : 'Set up Stripe'}
            </button>
          )}
        </div>
      </section>
    </div>,
    document.body,
  );
}
